import * as React from "react";

import * as styles from "./PageSubheader.module.less";

/**
 * Общая концепция построения страниц состоит в том, что есть как бы верхнеуровневые страницы.
 * Их заголовки выводятся в глобальном заголовке.
 * Но есть и вторичные страницы, для которых в глобальном заголовке выводятся хлебные крошки.
 * (Это всё делается через компонент PageLayout)
 * Однако, у вторичных страниц всё-таки могут быть свои заголовки, которые выводятся уже в зоне действия страницы.
 * Такой подзаголовок может совмещаться с блоком кнопок.
 * Отдельным компонентом (а не в составе PageLayout) сделан потому что кнопки могут быть частью формы.
 * В этом случае главный элемент страницы - форма, а подзаголовок выводится уже внутри формы.
 */

type PropsPageSubheader = {
  title?: React.ReactNode;
  children?: React.ReactNode | React.ReactNode[]; // для нескольких кнопок рекомендуется Fragment
};

export const PageSubheader: React.FC<PropsPageSubheader> = ({
  title,
  children,
}) => {
  if (!title && !children) return null;
  return (
    <div className={styles.box}>
      <div className={styles.title}>{title}</div>
      {children}
    </div>
  );
};
